import { MouseEventHandler, useContext, useState, FC } from "react";
import { StepNavigationContext } from "components/StepNavigation";
import StepNavigationStep from "components/StepNavigation/composition/StepNavigationStep";
import { saveEmailAndContinue } from "./core/modalConfigStepNewsletterMail.helpers";
import Button from "components/Inputs/Button";
import { Icons } from "utils/constants/icons";
import TextInput from "components/Inputs/TextInput";
import { Trans, useTranslation } from "react-i18next";
import { ModalConfigNewsleterContext } from "components/Modals/ModalConfig";
import { useEmail } from "utils/hooks/useEmail";
import { IProps } from "./core/modalConfigStepNewsletterMail.types";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { AppThunkDispatch } from "redux/configuration/configuration.types";

const ModalConfigStepNewsletterMail: FC<IProps> = ({ stepOrder }) => {
  const stepNavigationContext = useContext(StepNavigationContext);
  const { t } = useTranslation("modals", { keyPrefix: "newsletter.email" });
  const newsletterContext = useContext(ModalConfigNewsleterContext);
  const { email, setEmail } = { ...newsletterContext };
  const dispatch: AppThunkDispatch = useDispatch();
  const [tempEmail, setTempEmail] = useState<string>(email || "");
  const [saveError, setSaveError] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const { isValid, errorMessage } = useEmail({ email: tempEmail });

  const { entityId } = useParams();

  const handleNextStepClick: MouseEventHandler = async () => {
    setIsSaving(true);
    setSaveError(false);

    const saved = await saveEmailAndContinue(
      stepNavigationContext,
      setEmail,
      tempEmail,
      entityId,
      dispatch
    );
    setIsSaving(false);
    setSaveError(!saved);
  };

  return stepNavigationContext ? (
    <StepNavigationStep className="modal__content" step={stepOrder}>
      <div className="modal__img">
        <img
          className="modal__img__newsletter"
          src="/static/images/modals/newsletter.png"
          alt="newsletter icon"
        />
      </div>
      <h2 className="modal__title">{t("title")}</h2>
      <p>
        <Trans
          ns="modals"
          i18nKey="newsletter.email.subtitle"
          components={[<span className="c-primary fw-700"></span>]}
        />
      </p>
      <TextInput
        placeholder={t("placeholder")}
        value={tempEmail}
        setValue={(value) => {
          setTempEmail(value);
          setSaveError(false);
        }}
        className="modal__input"
        label={t("label")}
        type="email"
      />
      <div className="collect__error_container mb-4 c-error">
        {tempEmail.length > 0 && ((!isValid && errorMessage) || saveError) && (
          <p>{t(errorMessage || "errors.email.invalid")}</p>
        )}
      </div>
      <Button
        text={t("CTA")}
        onClick={handleNextStepClick}
        icon={Icons.chevronRight}
        className="modal__btn mt-0"
        disabled={!isValid}
        loading={isSaving}
      />
    </StepNavigationStep>
  ) : null;
};

export default ModalConfigStepNewsletterMail;
